import React, { useState } from 'react';
import { PiDotsThreeOutlineVerticalFill } from 'react-icons/pi';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

import { DataState } from '../../context/DataProvider';
import WorkflowCanvas from './WorkflowCanvas';
import WorkflowExecutionWindow from '../workflowExecution/WorkflowExecutionWindow';
import ToggleButton from './ToggleButton'; // Import the new ToggleButton

const WorkflowList = () => {
  // const [workflows, setWorkflows] = useState([]);
  const { workflows, setWorkflows } = DataState();
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [executionWindowOpen, setExecutionWindowOpen] = useState(false);
  const [selectedWorkflowId, setSelectedWorkflowId] = useState(null);

  // Fetch workflows from the backend
  // useEffect(() => {
  //   async function fetchWorkflows() {
  //     const data = await getWorkflows(userGoogleId); // Update the endpoint as needed
  //     //   const data = await response.json();
  //     setWorkflows(data);
  //   }
  //   fetchWorkflows();
  // }, []);

  const handleEditWorkflow = (workflowId) => {
    setSelectedWorkflowId(workflowId);
    setEditModalOpen(true);
  };
  const handleExecutionWindowClick = (workflowId) => {
    setSelectedWorkflowId(workflowId);
    setExecutionWindowOpen(true);
  };
  const closeEditModal = () => {
    setEditModalOpen(false);
    setSelectedWorkflowId(null);
  };
  const closeExecutionWindow = () => {
    setExecutionWindowOpen(false);
    setSelectedWorkflowId(null);
  };

  // Callback function to update the workflow list after a toggle
  const handleWorkflowUpdate = (workflowId, newDisabledState) => {
    setWorkflows((prevWorkflows) =>
      prevWorkflows.map((wf) =>
        wf.id === workflowId ? { ...wf, disabled: newDisabledState } : wf,
      ),
    );
  };

  return (
    <div className="mt-4 w-full">
      <div className="mt-5 flex max-h-[calc(100vh-200px)] flex-col gap-5 overflow-y-auto">
        {workflows.length > 0 ? (
          workflows.map((workflow) => (
            <div
              key={workflow.id}
              className="br-2 bg-2 text-p-text relative flex flex-col gap-2 rounded-md border px-4 py-3 transition-colors duration-150 ease-in-out"
            >
              <div className="flex items-center gap-2">
                {workflow?.apps_expanded?.map((i, index) => (
                  <div
                    key={index}
                    className="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded bg-white p-0.5"
                  >
                    <img src={i.image} alt="Trigger icon" />
                  </div>
                ))}
                <strong className="text-md flex-1 truncate font-medium">
                  {workflow.title || 'Untitled'}
                </strong>
                {/* MODIFICATION: Added ToggleButton and adjusted layout */}
                <div className="relative z-10 ml-auto flex items-center gap-4">
                  <ToggleButton
                    workflow={workflow}
                    onUpdate={handleWorkflowUpdate}
                  />
                  <DropdownMenu.Root>
                    <DropdownMenu.Trigger asChild>
                      <button
                        type="button"
                        className="text-md text-p-text -mr-1 flex items-center rounded-[3px] border-0 bg-transparent px-1 py-1 font-semibold transition-colors duration-150 ease-in-out disabled:cursor-not-allowed"
                      >
                        <span className="sr-only">Open workflow options</span>
                        <PiDotsThreeOutlineVerticalFill className="text-xl" />
                      </button>
                    </DropdownMenu.Trigger>
                    <DropdownMenu.Portal>
                      <DropdownMenu.Content
                        className="DropdownMenuContent z-20 overflow-hidden rounded-lg border border-zinc-700 bg-zinc-900 p-2 text-zinc-200 shadow-lg"
                        sideOffset={8}
                      >
                        {[
                          // { label: "Workflow Graph", onClick: () => { } },
                          // { label: "Execution Window", onClick: () => {  } },
                          {
                            label: 'Execution Window',
                            onClick: () => {
                              handleExecutionWindowClick(workflow.id);
                            },
                          },
                          {
                            label: 'Edit Workflow',
                            onClick: () => {
                              handleEditWorkflow(workflow.id);
                            },
                          },
                          { label: 'Delete Workflow', onClick: () => {} },
                        ].map((option, index) => (
                          <DropdownMenu.Item key={index}>
                            <button
                              onClick={option.onClick}
                              className="bg-1-hover block w-full rounded-md px-5 py-2 text-left text-sm transition-all duration-150 hover:bg-zinc-800 focus:bg-gray-700"
                            >
                              {option.label}
                            </button>
                          </DropdownMenu.Item>
                        ))}
                      </DropdownMenu.Content>
                    </DropdownMenu.Portal>
                  </DropdownMenu.Root>
                </div>
              </div>
              <p className="text-s-text br-1 bg-1 mt-2 rounded-xl border px-3 py-2 text-sm font-normal">
                {workflow.description || 'No Description'}
              </p>
            </div>
          ))
        ) : (
          <div className="bg-2 br-1 flex h-64 flex-col items-center justify-center gap-4 rounded-lg border p-3 text-center sm:h-96 sm:gap-5 sm:p-4">
            <span className="text-s-text text-sm sm:text-base">
              No workflows available
            </span>
            <span className="text-p-text text-lg font-semibold max-sm:w-[80%] sm:text-xl">
              Create your first workflow to get started
            </span>
          </div>
        )}
      </div>
      {/* Render WorkflowCanvas in a modal for editing */}
      {editModalOpen && (
        <div className="fixed inset-0 z-999 flex items-center justify-center bg-black bg-opacity-50">
          <div className="h-4/5 w-4/5 rounded bg-white shadow-lg">
            <WorkflowCanvas
              closeModal={closeEditModal}
              mode="edit"
              workflowId={selectedWorkflowId}
            />
          </div>
        </div>
      )}
      {executionWindowOpen && (
        <div className="fixed inset-0 z-999 flex items-center justify-center bg-black bg-opacity-50">
          <div className="h-4/5 w-4/5 rounded bg-white shadow-lg">
            <WorkflowExecutionWindow
              closeModal={closeExecutionWindow}
              // mode="edit"
              workflowId={selectedWorkflowId}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkflowList;
